import script from "./NewsButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./NewsButton.vue?vue&type=script&lang=ts&setup=true"

import "./NewsButton.vue?vue&type=style&index=0&id=7288225c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7288225c"]])

export default __exports__